<div class="card">
    <!-- HEADER -->
    <p-toolbar class="mb-3" [style]="{ 'background-color': '#f3f4f6', border: '0' }">
        <ng-template pTemplate="start">
            <div class="font-semibold text-2xl">Schede Deviatoi</div>
        </ng-template>
        <ng-template pTemplate="end">
            <div class="flex items-center gap-2">
                <button pButton label="Nuovo deviatoio" icon="pi pi-plus" [size]="'large'" (click)="openForm()"></button>
                <button pButton label="Stampa/Esporta" icon="pi pi-download" severity="success" [size]="'large'" (click)="onExportCSV()"></button>
            </div>
        </ng-template>
    </p-toolbar>

    <!-- TABELLA -->
    <p-table
        #dt
        [value]="deviatoi"
        [lazy]="false"
        [loading]="loading"
        dataKey="id"
        [totalRecords]="totalRecords"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 20, 50]"
        [resizableColumns]="true"
        [responsiveLayout]="'stack'"
        [scrollable]="true"
        styleClass="p-datatable-striped p-datatable-sm"
        [globalFilterFields]="['id', 'identificativo', 'descrizione']"
    >
        <ng-template pTemplate="caption">
            <div class="flex justify-between items-center">
                <span class="text-sm text-500"></span>
                <span class="p-input-icon-left">
                    <input pInputText type="text" placeholder="Cerca…" (keyup.enter)="onSearch($event)" />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="identificativo" style="width: 12rem">Identificativo <p-sortIcon field="identificativo"></p-sortIcon></th>
                <th pSortableColumn="deviatoioTipologia.labelFe">Tipologia</th>
                <th style="width: 260px">Azioni</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-r>
            <tr>
                <td><span class="font-medium">{{ r.identificativo }}</span></td>
                <td>{{ r.deviatoioTipologia?.labelFe }}</td>
                <td class="text-right">
                    <div class="flex justify-end gap-2">
                        <button pButton icon="pi pi-pencil" [size]="'large'" severity="warn" (click)="openForm(r)" pTooltip="Modifica deviatoio" tooltipPosition="top"></button>
                        <button pButton icon="pi pi-trash" [size]="'large'" severity="danger" (click)="onElimina(r)" pTooltip="Elimina deviatoio" tooltipPosition="top"></button>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessun deviatoio trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-toast></p-toast>
<p-confirmDialog [style]="{ width: '450px' }" rejectButtonStyleClass="p-button-text" acceptLabel="Elimina" rejectLabel="Annulla" header="Confermi l'eliminazione?" icon="pi pi-exclamation-triangle"> </p-confirmDialog>
